import { AxiosInstance } from 'axios';
import { IItem, IParameterSimple } from 'src/views/Admin/Items/types';
import { toResponse } from '../../genericToResponse';

export default (api: AxiosInstance, url: string) => async (item: IItem) => {
  const response = await api.post(url, item);
  return toResponse(response.data) as IParameterSimple[];
};



// WEBPACK FOOTER //
// ./src/services/api/admin/items/checkSimilar.ts